<template lang="pug">
	.accordion(v-if="items")
		.accordion-item(
			v-for="(item, index) in items"
			:key="index"
			:class="{'active-item': index === openItemId}"
			ref="accordionItems"
		)
			button.accordion-header(@click="toggleItem(index)")
				.accordion-header__text
					h3.accordion-header__title(v-if="item.title" v-html="item.title" )
					span.accordion-header__subtitle(v-if="item.description" v-html="item.description")
				//span {{ openItemId === item.id ? '−' : '+' }}
				.accordion-header__icon-wrap
					v-svg-icon.accordion-header__icon(icon="arrow-right" )

			transition(name="fade")
				.accordion-content.text-guide( v-html="item.content" :class="{'active-content': index === openItemId}")
</template>

<script>
import VSvgIcon from "./helpers/v-svg-icon.vue";

export default {
	components: {VSvgIcon},
	data() {
		return {
			data: null,
			openItemId: null,
		}
	},

	props: {
		items: {
			type: Array,
			default: null
		},
	},

	methods: {
		toggleItem(id) {
			this.openItemId = this.openItemId === id ? null : id;

			if (this.openItemId !== null) {
				this.$nextTick(() => {
					const targetElement = this.$refs.accordionItems[id];

					if (targetElement) {
						const offset = 40;
						const elementPosition = targetElement.getBoundingClientRect().top;
						const offsetPosition = elementPosition + window.scrollY - offset;

						window.scrollTo({
							top: offsetPosition,
							behavior: 'smooth'
						});
					}
				});
			}
		},

		dataSet(data) {
			this.data = data;
		}
	}
}
</script>